// PreloaderScene.js（重构版 - 使用子模块）
import Phaser from 'phaser';
import ErrorHandler from './modules/ErrorHandler.js';
import { validateAllLoadedMaps } from './modules/SceneRegistry.js';
import { ensureMapTextures } from './modules/LazyAssetLoader.js';
import PreloaderLoadLogic from './modules/Preloader/PreloaderLoadLogic.js';
import PreloaderLoadUI from './modules/Preloader/PreloaderLoadUI.js';

export default class PreloaderScene extends Phaser.Scene {
    constructor() {
        super('PreloaderScene');
    }
    
    preload() {
        this.loadLogic = new PreloaderLoadLogic(this);
        this.loadUI = new PreloaderLoadUI(this);
        
        this.loadUI.create();
        
        this.loadLogic.loadAllResources(
            (progress, status) => {
                this.loadUI.updateProgress(progress, status);
            },
            (key, type, data) => {
                this.loadUI.showTip(`已加载: ${key}`);
            }
        );
    }
    
    create() {
        try {
            this.loadUI.updateProgress(100, '加载完成！');
            this.loadUI.showTip('正在初始化游戏...');
            
            validateAllLoadedMaps(this);

            const worldMapJson = this.cache.json.get('chunk_1_4');
            if (worldMapJson) {
                this.loadUI.showTip('正在准备主世界起始区域...');
                ensureMapTextures(this, worldMapJson)
                    .then(() => this.finishPreloadAndTransition())
                    .catch((error) => {
                        ErrorHandler.handleError(error, '主世界地图资源', this);
                        this.finishPreloadAndTransition();
                    });
            } else {
                this.finishPreloadAndTransition();
            }
        } catch (error) {
            ErrorHandler.handleError(error, '资源加载', this);
            this.scene.start('LoginScene');
        }
    }
    
    finishPreloadAndTransition() {
        try {
            if (!this.scene.isActive(this)) {
                return;
            }

            this.loadUI.destroy();

            if (window.userInfo && window.userInfo.userId) {
                this.scene.start('TitleScene');
            } else {
                this.scene.start('LoginScene');
            }
        } catch (error) {
            ErrorHandler.handleError(error, '场景切换', this);
            this.scene.start('LoginScene');
        }
    }
}
